// Capability-aware landing (/v4 index) — not everyone can load Today.
const DEFAULT_PATH = '/v4';

/**
 * Where sign-in sends the browser: `returnTo` when it resolves to `origin` with the same scheme and
 * no userinfo, else the default landing. Returns the checked absolute address, since a path rebuilt
 * from it can be a protocol-relative `//evil.com`.
 */
export function resolvePostAuthPath(returnTo: string | null, origin: string): string {
  if (!returnTo) {
    return DEFAULT_PATH;
  }
  try {
    const url = new URL(returnTo, origin);
    const sameSite =
      url.origin === origin &&
      url.protocol === new URL(origin).protocol &&
      !url.username &&
      !url.password;
    return sameSite ? url.href : DEFAULT_PATH;
  } catch {
    return DEFAULT_PATH;
  }
}

const SIGN_IN_PATHS = ['/auth', '/login'];

/** The sign-in address for a signed-out visit, carrying where it was going; the sign-in page never returns to itself. */
export function signInPath(pathname: string, search: string): string {
  if (SIGN_IN_PATHS.includes(pathname)) {
    return '/auth';
  }
  return `/auth?return_to=${encodeURIComponent(pathname + search)}`;
}
